import React from 'react';
import { useTranslation } from 'react-i18next';

import { CHANNEL_SHORT_NAME_MAP, IChannel, PROTOCOL } from '@/entities/channel';

import { ChannelIconWithLabel } from '../ChannelIconWithLabel';

import {
  TWhatsappPersonalQrCodeDialogProps,
  WhatsappPersonalQrCodeDialog,
} from './WhatsappPersonalQrCodeDialog';

type TWhatsAppPersonalAuthDialogProps = TWhatsappPersonalQrCodeDialogProps & {
  channel: IChannel;
  isPending?: boolean;
};

export const WhatsAppPersonalAuthDialog = ({
  channel,
  isPending,
  ...otherProps
}: TWhatsAppPersonalAuthDialogProps) => {
  const { t } = useTranslation();

  return channel.protocol === PROTOCOL.WHATSAPP_GRAY ? (
    <WhatsappPersonalQrCodeDialog
      channel={channel}
      title={t('channels:authByQrCodeTitle')}
      additionalTitleSlot={
        <ChannelIconWithLabel
          label={CHANNEL_SHORT_NAME_MAP[PROTOCOL.WHATSAPP_GRAY]}
          protocol={PROTOCOL.WHATSAPP_GRAY}
        />
      }
      {...otherProps}
    />
  ) : null;
};
